module.exports = __webpack_public_path__ + "img/switch_on.b9c8243a.svg";